import React, { useEffect, useState } from "react";
import { Row, Col, Collapse, Icon } from "antd";

import SelectInput from "../../CommonFormItems/SelectInput/SelectInput";

const { Panel } = Collapse;

function resetFields(fields, setter, setFieldsValue) {
  const resetValues = {};
  const resetOptions = {};

  fields.forEach((field) => {
    resetValues[field] = undefined;
    resetOptions[`${field}Options`] = [];
  });

  setter((prev) => ({
    ...prev,
    ...resetOptions,
  }));

  setFieldsValue(resetValues);
}

function getContractOptions(userRoles) {
  const contracts = [];

  if (!userRoles?.data) return contracts;

  userRoles.data.forEach((profile) => {
    if (
      profile?.contractNumber &&
      !contracts.includes(profile.contractNumber)
    ) {
      contracts.push(profile.contractNumber);
    }
  });

  return contracts;
}

function getClientOptions(userRoles, contract) {
  const clients = [];

  if (!userRoles?.data || !contract) return clients;

  userRoles.data
    .filter((profile) => profile.contractNumber === contract)
    .forEach((profile) => {
      if (profile?.clientNumber && !clients.includes(profile.clientNumber)) {
        clients.push(profile.clientNumber);
      }
    });

  return clients;
}

function getLabellerOptions(userRoles, clientNumber) {
  const labellers = [];

  if (!userRoles?.data || !clientNumber) return labellers;

  userRoles.data
    .filter((profile) => profile.clientNumber === clientNumber)
    .forEach((profile) => {
      if (profile?.labellerCode && !labellers.includes(profile.labellerCode)) {
        labellers.push(profile.labellerCode);
      }
    });

  return labellers;
}

export default function MaterialRequestContractBlock({
  form,
  reduxUserProfiles,
  onContractCompleted,
  onContractReset,
}) {
  const { getFieldDecorator, setFieldsValue } = form;

  const [contractDetails, setContractDetails] = useState({
    contractNumberOptions: [],
    clientNumberOptions: [],
    labellerCodeOptions: [],
  });

  const handleDependencyChange = (
    value,
    name,
    previousValues = {},
    options = { shouldResetMaterialLimit: true },
  ) => {
    if (
      options.shouldResetMaterialLimit &&
      typeof onContractReset === "function"
    ) {
      onContractReset();
    }

    if (name === "contractNumber") {
      resetFields(
        ["clientNumber", "labellerCode"],
        setContractDetails,
        setFieldsValue,
      );

      if (!value) return;

      const clientOptions = getClientOptions(reduxUserProfiles, value);

      setContractDetails((prev) => ({
        ...prev,
        clientNumberOptions: clientOptions,
      }));

      if (clientOptions.length === 1) {
        const [onlyClient] = clientOptions;

        setFieldsValue({
          clientNumber: onlyClient,
        });

        handleDependencyChange(
          onlyClient,
          "clientNumber",
          {
            contractNumber: value,
          },
          { shouldResetMaterialLimit: false },
        );
      }
    }

    if (name === "clientNumber") {
      resetFields(["labellerCode"], setContractDetails, setFieldsValue);

      if (!value) return;

      const labellerOptions = getLabellerOptions(reduxUserProfiles, value);

      setContractDetails((prev) => ({
        ...prev,
        labellerCodeOptions: labellerOptions,
      }));

      if (labellerOptions.length === 1) {
        const [onlyLabeller] = labellerOptions;

        setFieldsValue({
          labellerCode: onlyLabeller,
        });

        notifyContractCompleted({
          contractNumber:
            previousValues.contractNumber ||
            form.getFieldValue("contractNumber"),
          clientNumber: value,
          labellerCode: onlyLabeller,
        });
      }
    }

    if (name === "labellerCode") {
      notifyContractCompleted({
        contractNumber: form.getFieldValue("contractNumber"),
        clientNumber: form.getFieldValue("clientNumber"),
        labellerCode: value,
      });
    }
  };

  const notifyContractCompleted = ({
    contractNumber,
    clientNumber,
    labellerCode,
  }) => {
    if (!contractNumber || !clientNumber || !labellerCode) return;

    onContractCompleted({
      contractNumber,
      clientNumber,
      labellerCode,
    });
  };

  useEffect(() => {
    const contractOptions = getContractOptions(reduxUserProfiles);

    setContractDetails((prev) => ({
      ...prev,
      contractNumberOptions: contractOptions,
    }));

    if (contractOptions.length === 1) {
      const [onlyContract] = contractOptions;

      setFieldsValue({
        contractNumber: onlyContract,
      });

      handleDependencyChange(
        onlyContract,
        "contractNumber",
        {},
        { shouldResetMaterialLimit: false },
      );
    }
  }, [reduxUserProfiles]);

  return (
    <div className="MaterialRequestContractBlock">
      {" "}
      <Row className="form-section">
        <Collapse
          defaultActiveKey={["1"]}
          expandIcon={({ isActive }) => (
            <Icon type="caret-right" rotate={isActive ? 90 : 0} />
          )}
        >
          <Panel
            header="Contrato"
            key="1"
            extra={<Icon type="minus-circle" />}
            className="Busca"
          >
            <Row
              type="flex"
              justify="space-between"
              gutter={[16, 16]}
              className="pr-grid-row contract-grid-row"
            >
              <Col xs={24} md={7} className="pr-col">
                <SelectInput
                  getFieldDecorator={getFieldDecorator}
                  label="Contrato"
                  name="contractNumber"
                  options={contractDetails.contractNumberOptions}
                  allowClear
                  disabled={contractDetails.contractNumberOptions.length <= 1}
                  callback={handleDependencyChange}
                  placeholder="Seleccione un contrato..."
                  required
                />
              </Col>

              <Col xs={24} md={7} className="pr-col pr-col-offset">
                <SelectInput
                  getFieldDecorator={getFieldDecorator}
                  label="Detallable"
                  name="clientNumber"
                  options={contractDetails.clientNumberOptions}
                  allowClear
                  disabled={contractDetails.clientNumberOptions.length <= 1}
                  callback={handleDependencyChange}
                  placeholder="Seleccione un detallable..."
                  required
                />
              </Col>

              <Col xs={24} md={7} className="pr-col pr-col-offset">
                <SelectInput
                  getFieldDecorator={getFieldDecorator}
                  label="Etiquetador"
                  name="labellerCode"
                  options={contractDetails.labellerCodeOptions}
                  allowClear
                  disabled={contractDetails.labellerCodeOptions.length <= 1}
                  callback={handleDependencyChange}
                  placeholder="Seleccione un etiquetador..."
                  required
                />
              </Col>
            </Row>
          </Panel>
        </Collapse>
      </Row>
    </div>
  );
}
